import { type GetPositionsForCaseQuery } from "~/graphql/supergraphTypes";
import { type CaseProgram } from "../index";

// Backend returns the literal string "None" as a placeholder when a position
// has no program assigned; treat it as absent so the popover doesn't render it.
const PLACEHOLDER_PROGRAM_NAME = "none";

const normalize = (name: string): string => name.trim().toLowerCase();

/**
 * Derive the list of program names for the investor's *other* positions,
 * excluding programs already attached to the current case. Names are deduped
 * case-insensitively and returned in first-seen order.
 */
export const getOtherProgramNames = (
  data: GetPositionsForCaseQuery | undefined,
  casePrograms: CaseProgram[],
): string[] => {
  const excluded = new Set(casePrograms.map((p) => normalize(p.name)));
  const seen = new Set<string>();
  const result: string[] = [];

  const push = (name: string | null | undefined) => {
    if (!name) return;
    const trimmed = name.trim();
    const key = trimmed.toLowerCase();
    if (!key || key === PLACEHOLDER_PROGRAM_NAME || excluded.has(key) || seen.has(key)) return;
    seen.add(key);
    result.push(trimmed);
  };

  const profile = data?.complianceProfile;
  for (const position of profile?.positions ?? []) {
    push(position?.onboardingCase?.program?.name);
  }
  for (const entry of profile?.complianceCases ?? []) {
    push(entry?.complianceCase?.program?.name);
  }

  return result;
};
